"use client";

import {
  FeatureFlagProvider,
  FiatPricingProvider,
  PassportProvider,
  QueryProvider,
} from "@/context";
import { AnalyticsProvider } from "@/context/AnalyticsProvider";
import { AssetImportProvider } from "@/context/AssetImportProvider";
import { BrazeProvider } from "@/context/BrazeProvider";
import { PreferencesProvider } from "@/context/PreferencesProvider";
import { ProfileDrawerProvider } from "@/context/ProfileDrawerContext";
import theme from "@/styles/theme";
import { ThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";

export function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <AnalyticsProvider>
      <PassportProvider>
        <FeatureFlagProvider>
          <QueryProvider>
            <PreferencesProvider>
              <FiatPricingProvider>
                <AssetImportProvider>
                  <ProfileDrawerProvider>
                    <BrazeProvider>
                      <ThemeProvider theme={theme}>{children}</ThemeProvider>
                    </BrazeProvider>
                  </ProfileDrawerProvider>
                </AssetImportProvider>
              </FiatPricingProvider>
            </PreferencesProvider>
          </QueryProvider>
        </FeatureFlagProvider>
      </PassportProvider>
    </AnalyticsProvider>
  );
}
